import { IRulerInfo, RulerModel } from '@/editor/entities/2d/rulerModel';
import { RulerGuideLineModel } from '@/editor/entities/2d/rulerGuideLineModel';
import editorEvent, { EditorEventName } from '@/editor/event/editorEvent';
import { globalStores } from '@/editor/stores';
import { EOperateMode, ESceneMode } from '@/editor/types';
import { collectWallRulerInfos } from '@/editor/utils/ruler/collect';

// 实体墙/隔墙相关标尺渲染管理
export class WallRulerManager {
  private _wallRulerModel = new RulerModel();
  private _chordGuideLineModel = new RulerGuideLineModel();
  private _rulerInfos: IRulerInfo[] = [];
  private _disposeSet = new Set<() => void>();

  constructor() {
    this._disposeSet
      .add(editorEvent.on(EditorEventName.SCENE_MODE_CHANGE, this.update))
      .add(editorEvent.on(EditorEventName.ENTITY_SELECTED, this.update))
      .add(editorEvent.on(EditorEventName.OPERATE_MODE_CHANGE, this.update))
      .add(editorEvent.on(EditorEventName.RESIZE, this.update))
      .add(editorEvent.on(EditorEventName.REFRESH_RULER, this.update))
      .add(globalStores.editorStateStore.onChange('moving', () => this.update()));
  }

  public update = () => {
    const showWallRuler =
      globalStores.visibilityStore.visibleState.ruler &&
      !globalStores.editorStateStore.moving &&
      globalStores.operateInfo.mode === EOperateMode.EMPTY &&
      !globalStores.editorStateStore.selected.entityId &&
      globalStores.sceneMode === ESceneMode.scene2d;

    if (!showWallRuler) {
      this._wallRulerModel.clear();
      this._chordGuideLineModel.clear();
      return;
    }

    const { rulerInfos, chordGuideLines } = collectWallRulerInfos(globalStores);
    this._rulerInfos = rulerInfos;
    this._chordGuideLineModel.update(chordGuideLines);
    this._wallRulerModel.updateModel(this._rulerInfos);
  };

  dispose() {
    this._disposeSet.forEach((cb) => cb());
    this._disposeSet.clear();
    this._chordGuideLineModel.dispose();
    this._wallRulerModel.dispose();
    this._rulerInfos.length = 0;
  }
}
